import { ISelfResponse } from '@/shared/interfaces';
import { atom } from 'jotai/index';

// Backing atom that holds the ISelfResponse we get from the server
export const selfResponseAtom = atom<ISelfResponse | null>();
